export * from './offer-details-skeleton';
